import * as React from 'react';
import { withTrashableContext } from '../../../hooks';
import Viewport from '../../../widgets/Viewport';
import { PageTitle } from '../../../widgets/PageTitle';
import { StatusSectionComponent } from './StatusSectionComponent';
import { useFetchStatusPageData } from '../../../hooks/useFetchStatusPageData';
import LoadingIndicator from '../../../widgets/LoadingIndicator';

export const RawStatusView: React.FunctionComponent = () => {
  const { loading, statusData } = useFetchStatusPageData();

  const dataSection = React.useMemo(
    () => (
      <>
        {statusData.length === 0 && <h2>Failed to retrieve data</h2>}
        {statusData.map((d) => {
          return (
            <StatusSectionComponent
              key={d.title}
              title={d.title}
              titleNode={d.titleNode}
              status={d.status}
              children={d.children || []}
              depth={0}
            />
          );
        })}
      </>
    ),
    [statusData],
  );

  return (
    <Viewport>
      <PageTitle title="Status Page" />
      {loading ? (
        <LoadingIndicator size="lg" centered>
          Fetching data...
        </LoadingIndicator>
      ) : (
        <div className="panel white-box">{dataSection}</div>
      )}
    </Viewport>
  );
};

export default withTrashableContext(RawStatusView);
